"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _elementUi = require("element-ui");

var _leaflet = _interopRequireDefault(require("leaflet"));

require("leaflet/dist/leaflet.css");

require("@/plugins/leaflet-heatmap");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var HeatMapComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(HeatMapComponent, _Mixins);

  var _super = _createSuper(HeatMapComponent);

  function HeatMapComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, HeatMapComponent);
    _this = _super.apply(this, arguments);
    _this.loading = false;
    _this.baseMap = null;
    return _this;
  }

  (0, _createClass2.default)(HeatMapComponent, [{
    key: "onMapDataChanges",
    value: function onMapDataChanges() {
      if (!this.baseMap) {
        return;
      }

      if (!this.mapData || this.mapData.length === 0) {
        this.resetMap();
        return;
      }

      this.refreshMap();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.initData();
    }
  }, {
    key: "initData",
    value: function initData() {
      var _onLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.baseMap) {
        this.baseMap.remove();
      }

      if (_leaflet.default) {
        this.leafletMap = _leaflet.default;
        var latLngStr = this.helper.get(this.$userData, 'latlng', '22.383591, 114.121658');
        var latLng = this.helper.removeWhitespace(latLngStr).split(',');
        var osm = this.leafletMap.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
        this.baseMap = this.leafletMap.map(this.id, {
          layers: [osm],
          zoom: 12,
          zoomControl: false,
          zoomAnimation: false
        }).setView(latLng, 12);
        this.leafletMap.control.zoom({
          position: 'bottomright'
        }).addTo(this.baseMap);

        if (this.onLoad || _onLoad) {
          this.refreshMap();
        }
      }
    }
  }, {
    key: "resetMap",
    value: function resetMap() {
      var _this2 = this;

      this.baseMap.eachLayer(function (lData) {
        if (lData instanceof _leaflet.default.HeatLayer) {
          _this2.baseMap.removeLayer(lData);
        }
      });
    }
  }, {
    key: "refreshMap",
    value: function refreshMap() {
      var _this3 = this;

      var latLngList = [];
      this.loading = true;
      this.resetMap();
      var latLngHeat = [];
      this.mapData.forEach(function (mData, mKey) {
        var cleanLatLng = _this3.helper.removeWhitespace(mData).split(',');

        if (cleanLatLng.length === 2) {
          var latLng = new _leaflet.default.LatLng(Number(cleanLatLng[0]), Number(cleanLatLng[1]));
          latLngList.push(latLng);
          latLngHeat.push([Number(cleanLatLng[0]), Number(cleanLatLng[1]), 20]);
        }
      });

      _leaflet.default.heatLayer(latLngHeat, {
        radius: 12
      }).addTo(this.baseMap);

      if (latLngList.length >= 1) {
        this.baseMap.fitBounds(latLngList);
      }

      setTimeout(function () {
        _this3.loading = false;
      }, 1000);
    }
  }]);
  return HeatMapComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], HeatMapComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], HeatMapComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String
})], HeatMapComponent.prototype, "id", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], HeatMapComponent.prototype, "onLoad", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: function _default() {
    return [];
  }
})], HeatMapComponent.prototype, "mapData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('mapData')], HeatMapComponent.prototype, "onMapDataChanges", null);
HeatMapComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'HeatMapComponent',
  components: {
    'el-progress': _elementUi.Progress
  }
})], HeatMapComponent);
var _default2 = HeatMapComponent;
exports.default = _default2;